import React, { useState } from "react";
import api from "../../services/api";

const Actions = ({ item, fiscal_year_id, ministryid, setQuestionData }) => {
  const [isExistence, setIsExistence] = useState(item.is_existence);
  const [hasContinuity, setHasContinuity] = useState(item.has_continuity);
  const [remarksValue, setRemarksValue] = useState(item.remarks || "");

  const handleExistanceChange = async (e) => {
    const value = e.target.value === "true" ? true : false;
    setIsExistence(value);
    submitInternalAnswer(value, hasContinuity, remarksValue);

    let response = await api.getInternalQuestions(
      fiscal_year_id,
      sessionStorage.getItem("provinceId"),
      ministryid
    );
    if (response && response.code === 200) {
      setQuestionData(response.response);
    }
  };

  const handleContinuityChange = (e) => {
    const value = e.target.value === "true" ? true : false;
    setHasContinuity(value);
    submitInternalAnswer(isExistence, value, remarksValue);
  };

  const handleRemarksChange = (e) => {
    const value = e.target.value;
    setRemarksValue(value);
  };

  const handleRemarksSubmit = (e) => {
    const value = e.target.value;
    setRemarksValue(value);
    submitInternalAnswer(isExistence, hasContinuity, value);
  };

  const submitInternalAnswer = async (existence, continuity, remarks) => {
    const reqBody = {
      fiscal_year_id: fiscal_year_id,
      ministry_id: ministryid,
      province_id: sessionStorage.getItem("provinceId"),
      internal_question_id: item.id,
      is_existence: existence,
      has_continuity: continuity,
      remarks: remarks,
    };
    const res = await api.submitInternalMarks(reqBody);
    if (res && res.code === 200) {
      // console.log("Success");
    }
  };

  return (
    <>
      <td>
        <div>
          {" "}
          <input
            value="true"
            onChange={handleExistanceChange}
            name={`existance${item.id}`}
            id={`existanceTrue${item.id}`}
            type="radio"
            checked={isExistence === true ? true : false}
          />{" "}
          <label htmlFor={`existanceTrue${item.id}`}>छ</label>
        </div>
        <div>
          {" "}
          <input
            value="false"
            onChange={handleExistanceChange}
            name={`existance${item.id}`}
            id={`existanceFalse${item.id}`}
            type="radio"
            checked={isExistence === false ? true : false}
          />{" "}
          <label htmlFor={`existanceFalse${item.id}`}>छैन</label>
        </div>
      </td>
      <td>
        {isExistence && (
          <>
            <div>
              {" "}
              <input
                value="true"
                onChange={handleContinuityChange}
                name={`continuation${item.id}`}
                id={`continuationTrue${item.id}`}
                type="radio"
                checked={hasContinuity === true ? true : false}
              />{" "}
              <label htmlFor={`continuationTrue${item.id}`}>छ</label>
            </div>
            <div>
              {" "}
              <input
                value="false"
                onChange={handleContinuityChange}
                name={`continuation${item.id}`}
                id={`continuationFalse${item.id}`}
                type="radio"
                checked={hasContinuity === false ? true : false}
              />{" "}
              <label htmlFor={`continuationFalse${item.id}`}>छैन</label>
            </div>
          </>
        )}
      </td>
      <td>
        <textarea
          className="form-control w-100"
          value={remarksValue}
          name={`remarks${item.id}`}
          onChange={handleRemarksChange}
          onBlur={handleRemarksSubmit}
        />
      </td>
    </>
  );
};

export default Actions;
